export class CONAEquipmentPayloadRequest {
    RequestID: number;
    MyCustomColumn: string;
}

export default CONAEquipmentPayloadRequest;